/*
 * @Descripttion: 新增发票页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:39:22
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-28 13:10:21
 */

import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer, useRef } from 'react'
import { useTypedSelector } from '../../redux/store'
import { usePageCache, useSkipInitEffect } from '../../tools/utilHooks'
import {
  AllowAccountRes,
  GET_INVOICE_DETAIL_DATA,
  GET_VERIFICATION_RESULT_DATA,
  INVOICE_VERIFICATION,
  POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP,
  POST_RECOGNIZE_INVOICE,
  RecognizeInvoiceParams,
  LANDER_SAVE_INVOICE,
  UPLOAD_FILES,
  GET_OMS_EXPRESSCOMPANY_LIST,
  SAVE_INVOICE_LOGISTICS,
  DOWNLOAD_SUPPLIER_ORDER_ACCEPT_TEMP,
  SUPPLIER_SAVE_INVOICE,
  GET_SUPPLIER_INVOICE_DETAIL_DATA,
  InvoiceParamItem,
  RedInvoiceEntryItem,
  SAVE_RED_INVOICE_ENTRY,
} from '../../api/orderManage'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import reducer, {
  setDataSourceAction,
  setFormDataAction,
  setIsAddModalVisivleAction,
  setSelectedRowKeysAction,
  setRouteParamsAction,
  reloadStateAction,
  initialState,
  setOriginRemovedListAction,
  setSelectedRowsAction,
  setInvoiceBatchModalVisibleAction,
  setBatchUploadLoadingAction,
  setInvoiceEntryTypeAction,
  setInvoiceListDataAction,
  setPreviewFileUrlAction,
  setIsPreviewModalVisibleAction,
  setAllInvoicePriceAction,
  setAllOrderPriceAction,
  setAddInvoiceEntrySubmitAction,
  setIsModalOpenAction,
  setInvoiceDetailDataAction,
  setCurrentInvoiceAction,
  setInvoiceDetailChangeFlagAction,
  setCheckingResultAction,
  setExrpotInvoiceTipAction,
  setIsSubmitButtonLoadingAction,
  setDelInvoiceIdListAction,
  setDelOrderIdListAction,
  setIsTemporaryStorageLoadingAction,
  setAddInvoiceEntryIdAction,
  setInvoiceDetailAction,
  setOkBtnLoadingAction,
  setTemporaryStorageDisabledAction,
  setPageLoadingAction,
  setLogisticsCompanyListAction,
  setFileRequireAction,
  setLogisticsInfoAction,
  setDeleteFileIdsAction,
  RouteParams,
  BtnType,
  FINANCIAL_INVOICE_FILE_TYPE,
  SendTicketAddressType,
  sendTicketAddressDict,
  joinAddressInfo,
} from './reducer'
import { setModuleDataAction } from '../../modules/pagecache'
import { CustomerConfirm } from '../../components/ModalUser'
import copy from 'copy-to-clipboard'
import { FinanicialInvoiceType } from './components/InvoiceEntryBatchModal'
import { RcFile } from 'antd/lib/upload'
import {
  GetLocalStorage,
  download,
  generateRegExp,
  getPicName,
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import moment from 'moment'
import { fileFile } from '../../modules/uploadfiles/hooks'
import _ from 'lodash'
import { userRouter } from '../../route'
import { history } from '../../redux/store'
import { HTTP } from '../../api/http'
import { uniq } from 'lodash'
import { InvoiceNatureValue, invoiceTypeEnum } from '@/global/enum/invoice'
import { bigCalc } from '@xhgj/xh-jsutils'
import { DOWNLOAD_RED_ACCEPT_TEMP } from '@/api/invoice'
import {
  collectRedDelId,
  convertDetailToReturnOrderDetailItemList,
  convertToReturnOrderDetailItemList,
} from '../RedInvoiceEntry/utils'
import { AddInvoiceEntryProps } from '.'
import { FRONT_KEY } from '@/global/config'
import {
  processCheckCode,
  getTotalTaxAmountMismatchMessage,
} from './utils'
import { extractInvoiceNumber } from '@/tools/regex'

const UseAddInvoiceEntryHook = (props: AddInvoiceEntryProps) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { pageType = 'BLUE' } = props
  const {
    dataSource,
    selectedRowKeys,
    selectedRows,
    originRemovedList,
    invoiceListData,
    currentInvoice,
    invoiceDetailChangeFlag,
    allOrderPrice,
    allInvoicePrice,
    delOrderIdList,
    delInvoiceIdList,
    addInvoiceEntryId,
    routeParams,
    deleteFileIds,
    invoiceDetail,
  } = state
  const dispatchRedux = useDispatch()
  const { closeCurrentTab } = usePageCache()
  const { state: routeState, pathname } = useLocation<RouteParams>()
  const CACHE_KEY = pathname
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [invoiceForm] = Form.useForm()
  const [invoiceDetailForm] = Form.useForm()
  const [logisticsInfoForm] = Form.useForm()
  const supRoute = userRouter[1].url
  const fileInput = useRef<HTMLInputElement>(null)

  const isRedTicket =
    pathname?.includes('/addRedInvoiceEntry') ||
    pathname?.includes('redInvoiceDetail')

  function isTotalTaxAmoutEqual() {
    // const { allInvoicePrice } = options
    if (pageType === 'BLUE') {
      return Number(allInvoicePrice) === Number(allOrderPrice)
    } else {
      // 红票：用正数计算差值，差值在 0.1 元以内允许提交
      const invoiceTotal = bigCalc.createBig(allInvoicePrice || 0).abs()
      const orderTotal = bigCalc.createBig(allOrderPrice || 0).abs()
      const diff = invoiceTotal.minus(orderTotal).abs()
      return diff.lte(bigCalc.createBig(0.1))
    }
  }
  const isTotalTaxAmoutNotEqualMemo = useMemo(
    () => !isTotalTaxAmoutEqual(),
    [allInvoicePrice, allOrderPrice, pageType],
  )
  // 获取缓存数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  function getReturnOrderIds() {
    return uniq(dataSource.map((item) => item.id))
  }
  // 提交/暂存新增发票
  const handleSubmit = async (type: BtnType) => {
    const logisticsFormData = logisticsInfoForm.getFieldsValue()
    if (type === 'temporaryStorage') {
      dispatch(setIsTemporaryStorageLoadingAction(true))
      const verificationTypeList = invoiceListData.map((item) => ({
        type: item.verificationType,
        num: item.invoiceNum,
      }))
      const currentInvoice = verificationTypeList.find(
        (item) => item.type === '1',
      )
      if (currentInvoice) {
        // 系统内已有此发票无法进行暂存
        message.error(
          `系统内已存在票号为${currentInvoice.num}的发票，无法暂存！`,
        )
        dispatch(setIsTemporaryStorageLoadingAction(false))
      } else {
        // if (!checkSellerName(invoiceListData)) {
        //   message.warning('发票销方与订单信息不一致，请核实')
        //   return
        // }
        // if (!checkPayerName(invoiceListData)) {
        //   message.warning('发票购方信息与订单不一致，请核实')
        //   return
        // }
        const params = {
          relationId: routeParams.id ?? '',
          invoiceParam: invoiceListData.map((item) => ({
            id: item.id ?? '',
            file: item.fileList ? item.fileList[0] : null,
            invoiceCode: item.invoiceCode,
            invoiceNum: item.invoiceNum,
            invoiceTime: item.invoiceTime,
            invoiceType: item.invoiceType,
            totalAmount: item.totalAmount,
            totalAmountIncludingTax: item.totalAmountIncludingTax,
            totalTaxAmount: item.totalTaxAmount,
            verificationType: item.verificationType,
            checkCode: processCheckCode(item),
            seller: item.sellerName,
          })),
          supplierId: getSupplierId(),
          userId: getUserId(),
          orderIds: dataSource.map((item) => item.id),
          deleteInvoiceIds: delInvoiceIdList,
          deleteOrderIds: delOrderIdList,
          logisticsCompany: logisticsFormData.logisticsCompany,
          logisticsNum: logisticsFormData.logisticsNum,
          deleteFileIds: deleteFileIds,
        }
        // 调用接口暂存数据，关闭页面
        let res: any = {}

        if (pageType === 'RED') {
          const redInvoiceOriginalData = uniq(
            invoiceListData
              .map((item) => extractInvoiceNumber(item.note))
              .filter(Boolean),
          ).join(',')
          const redNumber = uniq(
            (invoiceDetail.redInvoiceOriginal + ',' + redInvoiceOriginalData)
              .split(',')
              .filter(Boolean),
          ).join(',')
          const redParams = {
            relationId: routeParams.id,
            invoiceType: pageType,
            returnOrderIds: getReturnOrderIds(),
            invoiceParams: invoiceListData.map((item) => ({
              id: item.id ?? '',
              invoiceType: item.invoiceType,
              invoiceNum: item.invoiceNum,
              invoiceCode: item.invoiceCode,
              invoiceTime: item.invoiceTime,
              totalAmount: item.totalAmount,
              totalTaxAmount: item.totalTaxAmount,
              totalAmountIncludingTax: item.totalAmountIncludingTax,
              file: item.fileList ? item.fileList[0] : null,
              verificationType: item.verificationType,
              checkCode: processCheckCode(item),
              seller: item.sellerName,
              // relationId: 'TODO',
            })),
            redInvoiceOriginal: invoiceDetail.redInvoiceOriginal
              ? redNumber
              : redInvoiceOriginalData,
            logisticsCompany: logisticsFormData.logisticsCompany,
            logisticsNum: logisticsFormData.logisticsNum,
            isDraft: true,
          }
          res = await SAVE_RED_INVOICE_ENTRY(redParams)
        } else {
          if (routeParams.type === 'lander') {
            res = await LANDER_SAVE_INVOICE({ ...params, dateState: '2' })
          } else {
            res = await SUPPLIER_SAVE_INVOICE({ ...params, dateState: '2' })
          }
        }

        dispatch(setIsTemporaryStorageLoadingAction(false))
        if (isResponseCodeSuccess(res.code)) {
          message.success(res.msg)
          handleClosePage()
        }
      }
    } else {
      if (dataSource.length) {
        if (invoiceListData.length) {
          const numList = invoiceListData.map((item) => item.invoiceNum)
          if (numList.length !== _.uniq(numList).length) {
            message.warning('存在相同发票，请核对后重新提交！')
          } else {
            // if (!checkSellerName(invoiceListData)) {
            //   message.warning('发票销方与订单信息不一致，请核实')
            //   return
            // }
            // if (!checkPayerName(invoiceListData)) {
            //   message.warning('发票购方信息与订单不一致，请核实')
            //   return
            // }
            // 存在未验证且开票日期不是今天的发票则提交验真
            const notPassVerificationInvoice = invoiceListData.filter(
              (item) =>
                item.verificationType === '7' &&
                moment(item.invoiceTime).format('YYYYMMDD') !==
                  moment(new Date()).format('YYYYMMDD'),
            )
            let invoiceList: any = [...invoiceListData]
            if (notPassVerificationInvoice.length) {
              // 获取验真数据
              invoiceList = await getInvoiceVerificationResult(
                notPassVerificationInvoice,
                '7',
              )
            }
            const saveParams = {
              relationId: routeParams.id ?? '',
              invoiceParam: invoiceList.map((item: any) => ({
                id: item.id ?? '',
                file: item.fileList ? item.fileList[0] : null,
                invoiceCode: item.invoiceCode,
                invoiceNum: item.invoiceNum,
                invoiceTime: item.invoiceTime,
                invoiceType: item.invoiceType,
                totalAmount: item.totalAmount,
                totalAmountIncludingTax: item.totalAmountIncludingTax,
                totalTaxAmount: item.totalTaxAmount,
                verificationType: item.verificationType,
                checkCode: processCheckCode(item),
                seller: item.sellerName,
              })),
              supplierId: getSupplierId(),
              userId: getUserId(),
              orderIds: dataSource.map((item) => item.id),
              deleteInvoiceIds: delInvoiceIdList,
              deleteOrderIds: delOrderIdList,
              logisticsCompany: logisticsFormData.logisticsCompany,
              logisticsNum: logisticsFormData.logisticsNum,
              deleteFileIds: deleteFileIds,
            }
            const invoiceVerificationState = invoiceList.map(
              (item: any) => item.verificationType,
            )
            // 获取所有发票的验真状态 只有验真通过和未验真状态(当天开的票，验真系统无法验证)的发票可以提交
            if (judgeCanSubmit(_.uniq(invoiceVerificationState))) {
              // 发票与订单的价税合计满足当前入口的校验规则才可以提交
              if (!isTotalTaxAmoutNotEqualMemo) {
                dispatch(setIsSubmitButtonLoadingAction(true))
                // 提交发票数据
                let res: any = {}

                if (pageType === 'RED') {
                  const redInvoiceOriginalData = uniq(
                    invoiceList
                      .map((item: any) => extractInvoiceNumber(item.note))
                      .filter(Boolean),
                  ).join(',')
                  const redNumber = uniq(
                    (
                      invoiceDetail.redInvoiceOriginal +
                      ',' +
                      redInvoiceOriginalData
                    )
                      .split(',')
                      .filter(Boolean),
                  ).join(',')
                  const redParams = {
                    relationId: routeParams.id,
                    invoiceType: pageType,
                    returnOrderIds: getReturnOrderIds(),
                    invoiceParams: invoiceList.map((item: any) => ({
                      id: item.id ?? '',
                      invoiceType: item.invoiceType,
                      invoiceNum: item.invoiceNum,
                      invoiceCode: item.invoiceCode,
                      invoiceTime: item.invoiceTime,
                      totalAmount: item.totalAmount,
                      totalTaxAmount: item.totalTaxAmount,
                      totalAmountIncludingTax: item.totalAmountIncludingTax,
                      file: item.fileList ? item.fileList[0] : null,
                      verificationType: item.verificationType,
                      checkCode: processCheckCode(item),
                      seller: item.sellerName,
                      // relationId: 'TODO',
                    })),
                    redInvoiceOriginal: invoiceDetail.redInvoiceOriginal
                      ? redNumber
                      : redInvoiceOriginalData,
                    isDraft: false,
                    logisticsCompany: logisticsFormData.logisticsCompany,
                    logisticsNum: logisticsFormData.logisticsNum,
                  }
                  res = await SAVE_RED_INVOICE_ENTRY(redParams)
                } else {
                  if (routeParams.type === 'lander') {
                    res = await LANDER_SAVE_INVOICE({
                      ...saveParams,
                      dateState: '1',
                    })
                  } else {
                    res = await SUPPLIER_SAVE_INVOICE({
                      ...saveParams,
                      dateState: '1',
                    })
                  }
                }
                dispatch(setIsSubmitButtonLoadingAction(false))
                if (isResponseCodeSuccess(res.code)) {
                  dispatch(setAddInvoiceEntrySubmitAction(true))
                  dispatch(setAddInvoiceEntryIdAction(res.data))
                }
              } else {
                message.error(
                  getTotalTaxAmountMismatchMessage(pageType, routeParams.type),
                )
              }
            } else {
              message.error('存在未通过验真的发票，请核对后重新提交！')
            }
          }
        } else {
          message.warning('请添加发票！')
        }
      } else {
        message.warning('请添加订单！')
      }
    }
  }

  // 关闭添加订单弹窗
  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivleAction(false))
  }

  // 表格选中操作
  const onChangeCheck = (selectedRowKeys: any[], selectedRows: any[]) => {
    dispatch(setSelectedRowKeysAction(selectedRowKeys))
    dispatch(setSelectedRowsAction(selectedRows))
  }

  const handleAddClick = () => {
    dispatch(setIsAddModalVisivleAction(true))
  }

  const handleAddFinished = (selectedRows: AllowAccountRes[]) => {
    if (selectedRows.length) {
      // 电商供应商订单判断订单的下单平台是否一致
      // if (routeParams.type === 'lander') {
      //   const platformList = _.uniq(
      //     [...dataSource, ...selectedRows].map((item) => item.platform),
      //   )
      //   if (platformList.length > 1) {
      //     message.warning('不同项目的订单不能一起提交对账单！')
      //     return
      //   }
      // }
      for (const item of selectedRows) {
        if (item.titleOfTheContract !== routeParams.titleOfTheContract) {
          message.error('请勾选相同签约抬头的订单进行开票！')
          return
        }
      }
      dispatch(setDataSourceAction([...dataSource, ...selectedRows]))
      // 设置订单价税合计
      setOrderPrice([...dataSource, ...selectedRows])
      dispatch(setIsAddModalVisivleAction(false))
      const selectIds = selectedRows.map((item) => item.id)
      let delIdList = [...delOrderIdList]
      selectIds.forEach((item) => {
        if (delIdList.includes(item)) {
          delIdList = delIdList.filter((term) => term !== item)
        }
      })
      dispatch(setDelOrderIdListAction(delIdList))
      setOriginRemovedList(
        originRemovedList.filter(
          (item) => selectedRows.findIndex((e) => e.id === item.id) === -1,
        ),
      )
    }
  }

  const handleAddReturnFinished = (selectedRows: RedInvoiceEntryItem[]) => {
    if (selectedRows.length) {
      const finalList = convertToReturnOrderDetailItemList(selectedRows)
      for (const item of finalList) {
        if (item.titleOfTheContractName !== routeParams.titleOfTheContract) {
          message.warning('请勾选相同签约抬头的订单进行开票！')
          return
        }
      }
      if (
        _.uniq(
          [...(dataSource as any), ...selectedRows].map((item) => item.taxRate),
        ).length > 1
      ) {
        message.warning('不同税率的发票不能合并开票')
        return
      }
      dispatch(setDataSourceAction([...dataSource, ...finalList]))
      // // 设置订单价税合计
      setOrderPrice([...dataSource, ...finalList])
      dispatch(setIsAddModalVisivleAction(false))
      const selectIds = finalList.map((item) => item.id)
      let delIdList = [...delOrderIdList]
      selectIds.forEach((item) => {
        if (delIdList.includes(item)) {
          delIdList = delIdList.filter((term) => term !== item)
        }
      })
      dispatch(setDelOrderIdListAction(delIdList))
      setOriginRemovedList(
        originRemovedList.filter(
          (item) => selectedRows.findIndex((e) => e.id === item.id) === -1,
        ),
      )
    }
  }

  const handleClosePage = () => {
    closeCurrentTab()
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  // 删除订单
  const onDelete = () => {
    if (!selectedRowKeys.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
      onOk: () => {
        let list = []
        // 需要针对红票特殊处理
        if (pageType === 'RED') {
          const selectedItem = dataSource?.find((item) => {
            return selectedRowKeys.includes((item as any)?.[FRONT_KEY])
          })
          const delIds = collectRedDelId(dataSource, selectedRowKeys)
          list = dataSource.filter((item) => !delIds.includes(item.id))
          dispatch(setDelOrderIdListAction(delIds))
        } else {
          list = dataSource.filter((item) => !selectedRowKeys.includes(item.id))
          dispatch(setDelOrderIdListAction([...selectedRowKeys]))
        }

        dispatch(setDataSourceAction(list))
        // 设置订单价税合计
        setOrderPrice(list)
        setOriginRemovedList(
          selectedRows.filter((item) => item.type === 'origin'),
        )
        dispatch(setSelectedRowKeysAction([]))
        dispatch(setSelectedRowsAction([]))
      },
    })
  }

  const setOriginRemovedList = (val: AllowAccountRes[]) => {
    dispatch(setOriginRemovedListAction(val))
  }
  const addressInfoMemo = useMemo(() => {
    if (dataSource.length < 1) {
      return null
    }
    let addressType: SendTicketAddressType | undefined = undefined
    dataSource.forEach((item) => {
      if (item.titleOfTheContract === '万聚国际（杭州）供应链有限公司') {
        addressType = '万聚'
      } else if (item.titleOfTheContract === '咸亨国际科技股份有限公司') {
        addressType = '总部'
      }
    })
    if (!addressType) {
      return null
    }
    const addresssInfo =
      sendTicketAddressDict[addressType as SendTicketAddressType]

    return addresssInfo
  }, [dataSource])

  // 复制
  const onCopy = () => {
    // const template = orderTypeData.find((item) => item.des === routeParams.type)
    // ?.address as string
    const info = joinAddressInfo(addressInfoMemo)
    const msgTitle = '线下寄票地址'
    copy(info)
    message.success(`复制${msgTitle}成功`)
  }

  // 导出寄票随单
  const exrpotInvoiceWithOrder = async () => {
    if (dataSource.length) {
      const idList = dataSource.map((item) => item.id)
      if (routeParams.type === 'lander') {
        // 处理红票
        if (isRedTicket) {
          await DOWNLOAD_RED_ACCEPT_TEMP(idList)
          return
        }
        // 电商供应商订单
        POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP(idList)
      } else {
        // 供应商订单
        DOWNLOAD_SUPPLIER_ORDER_ACCEPT_TEMP(idList)
      }
    } else {
      message.error('订单为空！请添加订单 ')
    }
  }

  const changeBatchModalVisible = (
    val: boolean,
    type?: FinanicialInvoiceType,
  ) => {
    dispatch(setOkBtnLoadingAction(false))
    dispatch(setInvoiceBatchModalVisibleAction(val))
    type && dispatch(setInvoiceEntryTypeAction(type))
  }

  // 提交上传发票
  const onBatchModalSubmit = async () => {
    const formData = await invoiceForm.validateFields()
    dispatch(setOkBtnLoadingAction(true))
    const list = formData.invoiceList.map((item: any) => ({
      ...item,
      invoiceTime:
        typeof item.invoiceTime === 'string'
          ? item.invoiceTime
          : moment(moment(item.invoiceTime).format('YYYY-MM-DD')).valueOf(),
      verificationType: '90',
    }))
    dispatch(setInvoiceListDataAction([...invoiceListData, ...list]))
    // 计算发票价税合计
    dispatch(
      setAllInvoicePriceAction(
        getAllPrice([...invoiceListData, ...list], 'totalAmountIncludingTax'),
      ),
    )
    dispatch(setOkBtnLoadingAction(false))
    changeBatchModalVisible(false)
  }

  // 批量导入发票-上传文件
  const uploadFlag = useRef<number>(0)
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    const reg = generateRegExp(FINANCIAL_INVOICE_FILE_TYPE)
    const index = file.name.search(reg)
    if (FileList.length > 10) {
      message.error('上传失败：文件数量超出限制（10个）')
      uploadFlag.current = 0
      return false
    }
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      uploadFlag.current = 0
      return false
    }
    if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      uploadFlag.current = 0
      return false
    }
    uploadFlag.current++
    if (uploadFlag.current === FileList.length) {
      uploadfile(FileList)
      uploadFlag.current = 0
    }
    return false
  }

  // 2.调用接口上传文件
  const uploadfile = async (FileList: RcFile[]) => {
    changeBatchModalVisible(true, 'batchUpload')
    dispatch(setBatchUploadLoadingAction(true))
    const res = await UPLOAD_FILES({ type: 'invoice' }, FileList)
    if (isResponseCodeSuccess(res.code)) {
      await recognizeInvoice(
        res.data.map((item: any) => ({ url: item.url, fileId: item.id })),
      )
      dispatch(setBatchUploadLoadingAction(false))
    }
  }

  // 3.识别发票
  const recognizeInvoice = async (params: RecognizeInvoiceParams[]) => {
    const fileUrls = params.map((item) => item.url).join(',')
    const res = await POST_RECOGNIZE_INVOICE({ fileUrls })
    if (isResponseCodeSuccess(res.code)) {
      const invoiceList = res.data.map((item) => {
        if (
          item.invoiceNum &&
          item.invoiceTime &&
          item.totalTaxAmount &&
          item.totalAmountIncludingTax &&
          item.totalAmount &&
          item.invoiceType
        ) {
          message.success(res.msg)
          return {
            ...item,
            invoiceType: item.invoiceType?.key,
            invoiceTime: item.invoiceTime
              ? moment(Number(item.invoiceTime))
              : null,
            fileList: [
              {
                url: item.url,
                baseUrl: item.baseUrl,
                name: getPicName(item.url),
                id: item.fileId,
              },
            ],
            verificationType: '90',
            checkCode: processCheckCode(item),
          }
        } else {
          message.error(res.msg)
          return {}
        }
      })
      invoiceForm.setFieldsValue({
        invoiceList,
      })
    }
  }

  // 获取表格内input上传的文件
  const getInputFile = (e: any) => {
    const fileList = Object.values(e.target.files) as RcFile[]
    fileList.forEach((item: any) => beforeUpload(item, fileList))
    // 防止第二次选中同一个文件不调用change方法，导致无法重新打开弹框上传并识别文件
    e.target.value = ''
  }

  // 预览
  const showPreviewModal = (url: string) => {
    dispatch(setPreviewFileUrlAction(url))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  // 打包下载附件
  const onPackageDownload = async (files: fileFile[]) => {
    // 获取下载路径
    const url = `${files[0].baseUrl ? files[0].baseUrl : HTTP}${files[0].url}`
    download(url)
  }

  // 删除发票
  const handleDelInvoice = (ind: any) => {
    CustomerConfirm({
      title: '您正在删除发票',
      content: '删除后可重新添加，是否删除？',
      onOk: () => {
        const list = invoiceListData.filter((item, index) => index !== ind)
        dispatch(
          setAllInvoicePriceAction(
            getAllPrice(list, 'totalAmountIncludingTax'),
          ),
        )
        const delInvoice = invoiceListData[ind]
        dispatch(setInvoiceListDataAction(list))
        dispatch(
          setDelInvoiceIdListAction(
            uniq([...delInvoiceIdList, delInvoice.id ?? '']),
          ),
        )
      },
    })
  }

  // 计算价税合计/合计税额
  const getAllPrice = (val: any[], type: string) => {
    if (val.length) {
      return val
        .reduce(
          (accumulator, currentValue) =>
            accumulator + Number(currentValue[type] ?? 0),
          0,
        )
        .toFixed(2)
    } else {
      return 0
    }
  }

  // 打开发票详情弹窗
  const showInvoiceDetailModal = async (record: any, index: number) => {
    // 重置表单数据，避免发票详情弹框回显错误
    invoiceDetailForm.resetFields()
    dispatch(setCurrentInvoiceAction({ ...record, index: index }))
    invoiceDetailForm.setFieldsValue({
      ...record,
      invoiceTime: moment(record.invoiceTime),
    })
    // 打开发票弹窗时，根据当前发票类型判断附件是否必填
    changeInvoiceType(record.invoiceType)
    dispatch(setIsModalOpenAction(true))
    if (record.verificationType !== '4' || record.verificationType === '5') {
      let detailList = []
      if (record.detailList.length) {
        detailList = record.detailList.map((item: any) => ({
          goodsName: item.goods_name,
          standard: item.standard,
          unit: item.unit,
          num: item.num,
          netValue: item.net_value,
          detailAmount: item.detail_amount,
          taxRate: item.tax_rate,
          allTax: item.all_tax,
        }))
        detailList.push({
          goodsName: '合计',
          detailAmount: record.invoiceMoney,
          allTax: record.allTax,
        })
        dispatch(setCheckingResultAction(record.checkingResult))
      } else {
        // 调用接口获取发票详情数据
        const res = await GET_VERIFICATION_RESULT_DATA({
          invoiceNum: record.invoiceNum,
          // invoiceCode: record.invoiceCode,
          // invoiceTime: record.invoiceTime,
          // invoiceType: record.invoiceType,
          // totalAmount: record.totalAmount,
          // totalAmountIncludingTax: record.totalAmountIncludingTax,
          // totalTaxAmount: record.totalTaxAmount,
          // checkCode: record.invoiceType === '04' ? record.checkCode : '',
        })
        if (isResponseCodeSuccess(res.code)) {
          const ret = res.data?.result?.data?.detailList ?? []
          detailList =
            ret.length > 0 &&
            ret.map((item: any) => ({
              goodsName: item.goodsName,
              standard: item.standard,
              unit: item.unit,
              num: item.num,
              netValue: item.netValue,
              detailAmount: item.detailAmount,
              taxRate: item.taxRate,
              allTax: item.allTax,
            }))
          const r = res.data?.result?.data
          detailList.push({
            goodsName: '合计',
            detailAmount: r.invoiceMoney,
            allTax: r.allTax,
          })
          const rs = res.data?.result
          const checkingResult = {
            invoiceNum: rs.invoiceNumber,
            invoiceCode: rs.invoiceCode,
            invoiceTime: rs.invoiceDate,
            invoiceType: rs.invoiceType,
            totalAmount: Number(r.invoiceMoney),
            totalAmountIncludingTax: Number(r.allValoremTax),
            totalTaxAmount: Number(r.allTax),
          }
          dispatch(
            setCurrentInvoiceAction({
              ...record,
              index: index,
              note: r.note,
              checkingResult: checkingResult,
              purchaserName: r.purchaserName + r.purchaserTaxpayerNumber,
            }),
          )
          dispatch(setCheckingResultAction(checkingResult))
        }
      }
      dispatch(setInvoiceDetailDataAction(detailList))
    }
  }

  // 发票详情弹框确认
  const handleInvoiceDetailOk = async () => {
    if (invoiceDetailChangeFlag) {
      // 表单校验
      const formData = await invoiceDetailForm.validateFields()
      const list = invoiceListData.filter(
        (item, index) => index !== currentInvoice.index,
      )
      // 当前发票已验真，填写的数据与验真数据不一致，保存时只修改数据，不用再次提交验真
      if (currentInvoice.verificationType === '5') {
        list.push({
          ...currentInvoice,
          ...formData,
          verificationType: '3',
        })
        // 当前发票验真不通过，修改数据后重新提交验真
      } else {
        const formDataInvoiceTime = moment(
          moment(formData.invoiceTime).format('YYYY-MM-DD'),
        ).valueOf()
        list.push({
          ...currentInvoice,
          ...formData,
          verificationType: '90',
          invoiceTime:
            currentInvoice.invoiceTime !== formDataInvoiceTime
              ? formDataInvoiceTime
              : currentInvoice.invoiceTime,
        })
      }
      dispatch(setInvoiceListDataAction(list))
      dispatch(
        setAllInvoicePriceAction(getAllPrice(list, 'totalAmountIncludingTax')),
      )
      dispatch(setInvoiceDetailChangeFlagAction(false))
    }
    dispatch(setIsModalOpenAction(false))
  }

  // 关闭发票详情弹窗
  const handleInvoiceDetailCancel = () => {
    dispatch(setIsModalOpenAction(false))
  }

  // 发票详情页修改发票文件
  const changeInvoiceFile = async (file: any) => {
    dispatch(setInvoiceDetailChangeFlagAction(true))
    if (file.length) {
      message.loading('发票识别中，请耐心等待......')
      const fileUrls = file.map((item: any) => item.url).join(',')
      const res = await POST_RECOGNIZE_INVOICE({ fileUrls })
      if (isResponseCodeSuccess(res.code)) {
        const resData = res.data
        if (
          resData.every(
            (item) =>
              item.invoiceNum &&
              item.invoiceTime &&
              item.totalTaxAmount &&
              item.totalAmountIncludingTax &&
              item.totalAmount &&
              item.invoiceType,
          )
        ) {
          const fileList = [
            {
              url: resData[0].url,
              baseUrl: resData[0].baseUrl,
              name: getPicName(resData[0].url),
              id: resData[0].fileId,
            },
          ]
          const code = processCheckCode(resData?.[0])
          invoiceDetailForm.setFieldsValue({
            ...resData[0],
            fileList: fileList,
            invoiceType: resData[0].invoiceType.key,
            invoiceTime: moment(Number(resData[0].invoiceTime)),
            verificationType: '90',
            checkCode: code,
          })
          dispatch(
            setCurrentInvoiceAction({
              ...currentInvoice,
              fileList: fileList,
              verificationType: '90',
              checkCode: code,
            }),
          )
          message.success('识别成功！')
        } else {
          message.error('识别失败！')
        }
      }
    } else {
      if (currentInvoice.fileList[0].id) {
        dispatch(
          setDeleteFileIdsAction(
            uniq([...deleteFileIds, currentInvoice.fileList[0].id]),
          ),
        )
      }
      invoiceDetailForm.setFieldsValue({
        ...currentInvoice,
        fileList: [],
        verificationType: '90',
        invoiceTime: invoiceDetailForm.getFieldValue('invoiceTime'),
      })
      dispatch(setCurrentInvoiceAction({ ...currentInvoice, fileList: [] }))
    }
  }

  // 发票详情弹框表单修改
  const invoiceDetailChange = () => {
    dispatch(setInvoiceDetailChangeFlagAction(true))
  }

  // 一键填充
  const handlefillingResult = () => {
    dispatch(setInvoiceDetailChangeFlagAction(true))
    invoiceDetailForm.setFieldsValue({
      ...currentInvoice,
      ...currentInvoice.checkingResult,
      invoiceTime: moment(currentInvoice.checkingResult.invoiceTime),
    })
    dispatch(
      setCurrentInvoiceAction({
        ...currentInvoice,
        ...currentInvoice.checkingResult,
      }),
    )
  }

  // 调用验真接口
  const handleVerificationInvoice = async () => {
    dispatch(setExrpotInvoiceTipAction(false))
    // 发票列表数据更新，判断是否展示导出寄票随单提示
    invoiceListData.forEach((item) => {
      if (item.fileList) {
        if (!item.remarks) {
          dispatch(setExrpotInvoiceTipAction(true))
          return
        }
      }
    })
    // 发票列表数据更新，判断发票验真结果
    const waitVerificationList = invoiceListData.filter(
      (item) => item.verificationType === '90',
    )
    // 获取验真数据
    getInvoiceVerificationResult(waitVerificationList, '90')
  }

  // 获取验真数据
  const getInvoiceVerificationResult = async (
    waitverificationInvoiceList: any,
    type: string,
  ) => {
    let verificationOverList: any = []
    // 验真状态是未验真的发票且开票日期是当天的/验真过的无需验真
    if (type === '7') {
      verificationOverList = invoiceListData.filter(
        (item) =>
          item.verificationType !== type ||
          (item.verificationType === type &&
            moment(item.invoiceTime).format('YYYYMMDD') ===
              moment(new Date()).format('YYYYMMDD')),
      )
    } else {
      verificationOverList = invoiceListData.filter(
        (item) => item.verificationType !== type,
      )
    }
    const data = await Promise.all(
      waitverificationInvoiceList.map(async (item: any) => {
        const res = await INVOICE_VERIFICATION({
          ...item,
          invoiceCode: item.invoiceCode || '',
          totalTaxAmount: item.totalTaxAmount || '',
          relationId: routeParams.id || '',
          orderType: routeParams.orderType || '',
          titleOfTheContract: routeParams.titleOfTheContract || '',
          supplierId: getSupplierId(),
          invoiceSeller: item.sellerName,
          sellerName: GetLocalStorage('ENTERPRISE_NAME'),
          apiSource: '1',
        })
        if (isResponseCodeSuccess(res.code)) {
          return res.data
        } else {
          return {}
        }
      }),
    )
    if (data.length) {
      const newInvoiceListData = waitverificationInvoiceList.map(
        (item: any, index: number) => {
          const curData: any = data[index]
          if (
            curData &&
            curData.resultType &&
            curData.resultType.key !== '1' &&
            curData.resultType.key !== '4' &&
            curData.resultType.key !== '6' &&
            curData.resultType.key !== '7'
          ) {
            const cueInvoiceDetailInfo =
              curData.invoiceVerificationInfo.result.data
            return {
              ...item,
              verificationType: curData.resultType.key,
              detailList: cueInvoiceDetailInfo.detailList,
              note: cueInvoiceDetailInfo.note,
              invoiceMoney:
                curData.invoiceVerificationInfo.result.data.invoice_money,
              allTax: curData.invoiceVerificationInfo.result.data.all_tax,
              checkingResult: {
                invoiceNum:
                  curData.invoiceVerificationInfo.result.invoice_number,
                invoiceCode:
                  curData.invoiceVerificationInfo.result.invoice_code,
                invoiceTime:
                  curData.invoiceVerificationInfo.result.invoice_date,
                invoiceType:
                  curData.invoiceVerificationInfo.result.invoice_type,
                totalAmount: cueInvoiceDetailInfo.invoice_money,
                totalAmountIncludingTax: cueInvoiceDetailInfo.all_valorem_tax,
                totalTaxAmount: cueInvoiceDetailInfo.all_tax,
              },
              purchaserName:
                cueInvoiceDetailInfo.purchaser_name +
                cueInvoiceDetailInfo.purchaser_taxpayer_number,
            }
          } else {
            return {
              ...item,
              verificationType: curData.resultType
                ? curData.resultType.key
                : '6',
            }
          }
        },
      )
      dispatch(
        setInvoiceListDataAction([
          ...verificationOverList,
          ...newInvoiceListData,
        ]),
      )
      return [...verificationOverList, ...newInvoiceListData]
    }
  }

  // 手动重新调用验真接口
  const reloadVerificationInvoice = async (record: any, ind: number) => {
    const res = await INVOICE_VERIFICATION({
      ...record,
      invoiceCode: record.invoiceCode || '',
      totalTaxAmount: record.totalTaxAmount || '',
      relationId: routeParams.id || '',
      orderType: routeParams.orderType || '',
      titleOfTheContract: routeParams.titleOfTheContract || '',
      supplierId: getSupplierId(),
      invoiceSeller: record.sellerName,
      sellerName: GetLocalStorage('ENTERPRISE_NAME'),
      apiSource: '1',
    })
    let newInvoiceItem = {}
    if (
      isResponseCodeSuccess(res.code) &&
      res.data.resultType &&
      res.data.resultType.key !== '1' &&
      res.data.resultType.key !== '4' &&
      res.data.resultType.key !== '6'
    ) {
      // 验真通过修改数据
      newInvoiceItem = {
        ...record,
        verificationType: res.data.resultType.key,
        detailList: res.data.invoiceVerificationInfo.result.data.detailList,
        note: res.data.invoiceVerificationInfo.result.data.note,
        invoiceMoney:
          res.data.invoiceVerificationInfo.result.data.invoice_money,
        allTax: res.data.invoiceVerificationInfo.result.data.all_tax,
        checkingResult: {
          invoiceNum: res.data.invoiceVerificationInfo.result.invoice_number,
          invoiceCode: res.data.invoiceVerificationInfo.result.invoice_code,
          invoiceTime: res.data.invoiceVerificationInfo.result.invoice_date,
          invoiceType: res.data.invoiceVerificationInfo.result.invoice_type,
          totalAmount:
            res.data.invoiceVerificationInfo.result.data.invoice_money,
          totalAmountIncludingTax:
            res.data.invoiceVerificationInfo.result.data.all_valorem_tax,
          totalTaxAmount: res.data.invoiceVerificationInfo.result.data.all_tax,
        },
      }
    } else {
      // 接口调用失败
      newInvoiceItem = {
        ...record,
        verificationType: '6',
      }
    }
    const list = invoiceListData.filter((item, index) => index !== ind)
    list.push(newInvoiceItem)
    dispatch(
      setAllInvoicePriceAction(getAllPrice(list, 'totalAmountIncludingTax')),
    )
    dispatch(setInvoiceListDataAction(list))
  }

  // 提交成功 跳转至发票详情页面
  const jumpToInvoiceDetail = () => {
    // 点击后将标识置为false展示详情页，避免在详情页下提交点击后页面数据异常
    dispatch(setAddInvoiceEntrySubmitAction(false))
    // 当前在新增页面时提交成功关闭页面并跳转至详情页
    if (pathname === '/srm/addInvoiceEntry') {
      handleClosePage()
      const url = supRoute + '/invoiceDetail'
      history.replace({
        pathname: url,
        state: {
          id: addInvoiceEntryId,
          type: routeParams.type,
        },
      })
      // 发票单状态为驳回时重新提交后刷新页面数据
    } else {
      // 获取最新数据
      getData({ id: addInvoiceEntryId, ...routeState })
    }
  }

  // 修改发票列表列数据
  const changeInvoiceListColumns = (state: string, columns: any[]) => {
    if (state === '1' || state === '3') {
      return columns.filter((item) => item.key !== 'operate')
    } else {
      return columns
    }
  }

  // 获取详情数据
  const getData = async (params: RouteParams) => {
    dispatch(setPageLoadingAction(true))
    let res: any = {}
    if (params.type === 'lander') {
      res = await GET_INVOICE_DETAIL_DATA({
        relationDataId: params.id as string,
      })
    } else {
      res = await GET_SUPPLIER_INVOICE_DETAIL_DATA({
        relationDataId: params.id as string,
      })
    }

    if (isResponseCodeSuccess(res.code)) {
      dispatch(setInvoiceDetailAction(res.data))
      // 发票列表 (设置发票详情列表为空数据，点击发票号时调用接口获取详情数据)
      const invoiceList = res.data.invoices.map((item: InvoiceParamItem) => ({
        ...item,
        detailList: [],
        fileList: item.file
          ? [
              {
                ...item.file,
                name: '附件',
                baseUrl: GetLocalStorage('BASEURL'),
              },
            ]
          : [],
      }))
      dispatch(setInvoiceListDataAction(invoiceList))
      // 设置发票价税合计
      dispatch(
        setAllInvoicePriceAction(
          Number(res.data.invoiceTotalAmountIncludingTax),
        ),
      )
      if (pageType === 'RED') {
        const list = convertDetailToReturnOrderDetailItemList(
          res.data?.returnDetailList || [],
        )
        dispatch(setDataSourceAction(list))
        setOrderPrice(list)
      } else {
        // 订单明细
        dispatch(setDataSourceAction(res.data.orders))
      }

      if (pageType !== 'RED') {
        // 设置订单价税合计
        dispatch(
          setAllOrderPriceAction(Number(res.data.orderTotalAmountIncludingTax)),
        )
      }

      // 设置物流信息
      const logisticsInfo = {
        logisticsCompany: res.data.logisticsCompany,
        logisticsNum: res.data.logisticsNum,
      }
      logisticsInfoForm.setFieldsValue(logisticsInfo)
      dispatch(setLogisticsInfoAction(logisticsInfo))
      dispatch(setPageLoadingAction(false))
    }
  }

  // 获取物流公司列表
  const getExpressList = async () => {
    const res = await GET_OMS_EXPRESSCOMPANY_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setLogisticsCompanyListAction(res.data))
    }
  }

  // 保存物流信息
  const saveLogisticsInfo = async () => {
    const logisticsFormData = logisticsInfoForm.getFieldsValue()
    if (logisticsFormData.logisticsCompany && logisticsFormData.logisticsNum) {
      const params = {
        logisticsCompany: logisticsFormData.logisticsCompany,
        logisticsNum: logisticsFormData.logisticsNum,
        invoiceOrderId: routeParams.id as string,
      }
      const res = await SAVE_INVOICE_LOGISTICS({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success(res.msg)
        dispatch(
          setLogisticsInfoAction({
            logisticsCompany: logisticsFormData.logisticsCompany,
            logisticsNum: logisticsFormData.logisticsNum,
          }),
        )
      }
    } else {
      if (!logisticsFormData.logisticsCompany) {
        message.warning('请选择物流公司！')
      } else if (!logisticsFormData.logisticsNum) {
        message.warning('请输入物流单号')
      }
    }
  }

  // 修改发票种类时，判断附件是否必传
  const changeInvoiceType = (type: string) => {
    if (
      invoiceTypeEnum.isLabelsMatchValue(
        [
          '增值税电子专用票',
          '电子发票（增值税专用发票）',
          '增值税电子普通发票',
          '电子发票（普通发票）',
        ],
        type,
      )
    ) {
      dispatch(setFileRequireAction(true))
    } else {
      dispatch(setFileRequireAction(false))
    }
  }

  // 判断当前发票列表数据是否可以提交
  const judgeCanSubmit = (arr: string[]) => {
    if (arr.length === 1) {
      // 7-当天票未验真  3-已验真
      if (arr.includes('7') || arr.includes('3')) {
        return true
      }
    } else if (arr.length === 2) {
      if (arr.includes('7') && arr.includes('3')) {
        return true
      }
    }
    return false
  }

  // 缓存发票页物流信息
  const onLogisticsInfoFormChange = () => {
    dispatch(setLogisticsInfoAction(logisticsInfoForm.getFieldsValue()))
  }

  // 设置订单价税合计
  const setOrderPrice = (data: any[]) => {
    if (isRedTicket) {
      const sums = bigCalc.sumListByFieldNameBig(
        data,
        'totalAmountIncludingTax',
      )
      dispatch(setAllOrderPriceAction(sums.toFixed(2)))
      return
    }
    if (routeParams.type === 'lander') {
      // 电商供应商订单价税合计
      dispatch(
        setAllOrderPriceAction(getAllPrice(data, 'totalAmountIncludingTax')),
      )
    } else {
      // 供应商订单价税合计
      dispatch(setAllOrderPriceAction(getAllPrice(data, 'finalPrice')))
    }
  }

  useEffect(() => {
    getExpressList()
    const flag = getpagecache()
    if (flag && !routeState) {
      dispatch(reloadStateAction(flag))
      logisticsInfoForm.setFieldsValue(flag.logisticsInfo)
    } else {
      dispatch(setRouteParamsAction(routeState))
      if (routeState.data) {
        dispatch(setDataSourceAction(routeState.data))
        setOrderPrice(routeState.data || [])
      }
      // 点击发票号跳转至详情页 调用接口获取页面详情数据
      if (routeState.id) {
        getData(routeState)
      }
    }
    // eslint-disable-next-line
  }, [])

  // 发票列表数据变更时，判断验真状态
  useEffect(() => {
    if (invoiceListData.length) {
      handleVerificationInvoice()
    }
    // eslint-disable-next-line
  }, [invoiceListData])

  // 订单列表无数据时，禁用'暂存'按钮
  useEffect(() => {
    if (!dataSource.length) {
      dispatch(setTemporaryStorageDisabledAction(true))
    } else {
      dispatch(setTemporaryStorageDisabledAction(false))
    }
  }, [dataSource])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  // // invoiceListData：发票
  // const checkSellerName = (invoiceListData: any) => {
  //   const sellerNameList = invoiceListData.map(
  //     (item: { sellerName: string }) => item.sellerName,
  //   )
  //   return sellerNameList?.every(
  //     (item: string) => convertToFullWidth(item) === getSupplierName(),
  //   )
  // }

  // const checkPayerName = (invoiceListData: any) => {
  //   const payerNameList = invoiceListData.map(
  //     (item: { payerName: string }) => item.payerName,
  //   )
  //   return payerNameList?.every(
  //     (item: string) => convertToFullWidth(item) === getSupplierName(),
  //   )
  // }

  return {
    hooksState: state,
    addressInfoMemo,
    fileInput,
    handleAddClick,
    handleAddOrderModalCancel,
    handleAddFinished,
    handleSubmit,
    onChangeCheck,
    handleClosePage,
    handleFormDataChange,
    onDelete,
    onCopy,
    exrpotInvoiceWithOrder,
    invoiceForm,
    invoiceDetailForm,
    changeBatchModalVisible,
    onBatchModalSubmit,
    beforeUpload,
    getInputFile,
    showPreviewModal,
    cancelPreviewModal,
    onPackageDownload,
    handleDelInvoice,
    showInvoiceDetailModal,
    handleInvoiceDetailOk,
    handleInvoiceDetailCancel,
    changeInvoiceFile,
    invoiceDetailChange,
    handlefillingResult,
    reloadVerificationInvoice,
    jumpToInvoiceDetail,
    changeInvoiceListColumns,
    logisticsInfoForm,
    saveLogisticsInfo,
    changeInvoiceType,
    onLogisticsInfoFormChange,
    handleAddReturnFinished,
    isTotalTaxAmoutNotEqualMemo,
  }
}

export default UseAddInvoiceEntryHook
/*
 * @Descripttion: 新增发票页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:39:22
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-28 13:10:21
 */

import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer, useRef } from 'react'
import { useTypedSelector } from '../../redux/store'
import { usePageCache, useSkipInitEffect } from '../../tools/utilHooks'
import {
  AllowAccountRes,
  GET_INVOICE_DETAIL_DATA,
  GET_VERIFICATION_RESULT_DATA,
  INVOICE_VERIFICATION,
  POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP,
  POST_RECOGNIZE_INVOICE,
  RecognizeInvoiceParams,
  LANDER_SAVE_INVOICE,
  UPLOAD_FILES,
  GET_OMS_EXPRESSCOMPANY_LIST,
  SAVE_INVOICE_LOGISTICS,
  DOWNLOAD_SUPPLIER_ORDER_ACCEPT_TEMP,
  SUPPLIER_SAVE_INVOICE,
  GET_SUPPLIER_INVOICE_DETAIL_DATA,
  InvoiceParamItem,
  RedInvoiceEntryItem,
  SAVE_RED_INVOICE_ENTRY,
} from '../../api/orderManage'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import reducer, {
  setDataSourceAction,
  setFormDataAction,
  setIsAddModalVisivleAction,
  setSelectedRowKeysAction,
  setRouteParamsAction,
  reloadStateAction,
  initialState,
  setOriginRemovedListAction,
  setSelectedRowsAction,
  setInvoiceBatchModalVisibleAction,
  setBatchUploadLoadingAction,
  setInvoiceEntryTypeAction,
  setInvoiceListDataAction,
  setPreviewFileUrlAction,
  setIsPreviewModalVisibleAction,
  setAllInvoicePriceAction,
  setAllOrderPriceAction,
  setAddInvoiceEntrySubmitAction,
  setIsModalOpenAction,
  setInvoiceDetailDataAction,
  setCurrentInvoiceAction,
  setInvoiceDetailChangeFlagAction,
  setCheckingResultAction,
  setExrpotInvoiceTipAction,
  setIsSubmitButtonLoadingAction,
  setDelInvoiceIdListAction,
  setDelOrderIdListAction,
  setIsTemporaryStorageLoadingAction,
  setAddInvoiceEntryIdAction,
  setInvoiceDetailAction,
  setOkBtnLoadingAction,
  setTemporaryStorageDisabledAction,
  setPageLoadingAction,
  setLogisticsCompanyListAction,
  setFileRequireAction,
  setLogisticsInfoAction,
  setDeleteFileIdsAction,
  RouteParams,
  BtnType,
  FINANCIAL_INVOICE_FILE_TYPE,
  SendTicketAddressType,
  sendTicketAddressDict,
  joinAddressInfo,
} from './reducer'
import { setModuleDataAction } from '../../modules/pagecache'
import { CustomerConfirm } from '../../components/ModalUser'
import copy from 'copy-to-clipboard'
import { FinanicialInvoiceType } from './components/InvoiceEntryBatchModal'
import { RcFile } from 'antd/lib/upload'
import {
  GetLocalStorage,
  download,
  generateRegExp,
  getPicName,
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import moment from 'moment'
import { fileFile } from '../../modules/uploadfiles/hooks'
import _ from 'lodash'
import { userRouter } from '../../route'
import { history } from '../../redux/store'
import { HTTP } from '../../api/http'
import { uniq } from 'lodash'
import { InvoiceNatureValue, invoiceTypeEnum } from '@/global/enum/invoice'
import { bigCalc } from '@xhgj/xh-jsutils'
import { DOWNLOAD_RED_ACCEPT_TEMP } from '@/api/invoice'
import {
  collectRedDelId,
  convertDetailToReturnOrderDetailItemList,
  convertToReturnOrderDetailItemList,
} from '../RedInvoiceEntry/utils'
import { AddInvoiceEntryProps } from '.'
import { FRONT_KEY } from '@/global/config'
import {
  processCheckCode,
  getTotalTaxAmountMismatchMessage,
} from './utils'
import { extractInvoiceNumber } from '@/tools/regex'

const UseAddInvoiceEntryHook = (props: AddInvoiceEntryProps) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { pageType = 'BLUE' } = props
  const {
    dataSource,
    selectedRowKeys,
    selectedRows,
    originRemovedList,
    invoiceListData,
    currentInvoice,
    invoiceDetailChangeFlag,
    allOrderPrice,
    allInvoicePrice,
    delOrderIdList,
    delInvoiceIdList,
    addInvoiceEntryId,
    routeParams,
    deleteFileIds,
    invoiceDetail,
  } = state
  const dispatchRedux = useDispatch()
  const { closeCurrentTab } = usePageCache()
  const { state: routeState, pathname } = useLocation<RouteParams>()
  const CACHE_KEY = pathname
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [invoiceForm] = Form.useForm()
  const [invoiceDetailForm] = Form.useForm()
  const [logisticsInfoForm] = Form.useForm()
  const supRoute = userRouter[1].url
  const fileInput = useRef<HTMLInputElement>(null)

  const isRedTicket =
    pathname?.includes('/addRedInvoiceEntry') ||
    pathname?.includes('redInvoiceDetail')

  function isTotalTaxAmoutEqual() {
    // const { allInvoicePrice } = options
    if (pageType === 'BLUE') {
      return Number(allInvoicePrice) === Number(allOrderPrice)
    } else {
      // 红票：用正数计算差值，差值在 0.1 元以内允许提交
      const invoiceTotal = bigCalc.createBig(allInvoicePrice || 0).abs()
      const orderTotal = bigCalc.createBig(allOrderPrice || 0).abs()
      const diff = invoiceTotal.minus(orderTotal).abs()
      return diff.lte(bigCalc.createBig(0.1))
    }
  }
  const isTotalTaxAmoutNotEqualMemo = useMemo(
    () => !isTotalTaxAmoutEqual(),
    [allInvoicePrice, allOrderPrice, pageType],
  )
  // 获取缓存数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  function getReturnOrderIds() {
    return uniq(dataSource.map((item) => item.id))
  }
  // 提交/暂存新增发票
  const handleSubmit = async (type: BtnType) => {
    const logisticsFormData = logisticsInfoForm.getFieldsValue()
    if (type === 'temporaryStorage') {
      dispatch(setIsTemporaryStorageLoadingAction(true))
      const verificationTypeList = invoiceListData.map((item) => ({
        type: item.verificationType,
        num: item.invoiceNum,
      }))
      const currentInvoice = verificationTypeList.find(
        (item) => item.type === '1',
      )
      if (currentInvoice) {
        // 系统内已有此发票无法进行暂存
        message.error(
          `系统内已存在票号为${currentInvoice.num}的发票，无法暂存！`,
        )
        dispatch(setIsTemporaryStorageLoadingAction(false))
      } else {
        // if (!checkSellerName(invoiceListData)) {
        //   message.warning('发票销方与订单信息不一致，请核实')
        //   return
        // }
        // if (!checkPayerName(invoiceListData)) {
        //   message.warning('发票购方信息与订单不一致，请核实')
        //   return
        // }
        const params = {
          relationId: routeParams.id ?? '',
          invoiceParam: invoiceListData.map((item) => ({
            id: item.id ?? '',
            file: item.fileList ? item.fileList[0] : null,
            invoiceCode: item.invoiceCode,
            invoiceNum: item.invoiceNum,
            invoiceTime: item.invoiceTime,
            invoiceType: item.invoiceType,
            totalAmount: item.totalAmount,
            totalAmountIncludingTax: item.totalAmountIncludingTax,
            totalTaxAmount: item.totalTaxAmount,
            verificationType: item.verificationType,
            checkCode: processCheckCode(item),
            seller: item.sellerName,
          })),
          supplierId: getSupplierId(),
          userId: getUserId(),
          orderIds: dataSource.map((item) => item.id),
          deleteInvoiceIds: delInvoiceIdList,
          deleteOrderIds: delOrderIdList,
          logisticsCompany: logisticsFormData.logisticsCompany,
          logisticsNum: logisticsFormData.logisticsNum,
          deleteFileIds: deleteFileIds,
        }
        // 调用接口暂存数据，关闭页面
        let res: any = {}

        if (pageType === 'RED') {
          const redInvoiceOriginalData = uniq(
            invoiceListData
              .map((item) => extractInvoiceNumber(item.note))
              .filter(Boolean),
          ).join(',')
          const redNumber = uniq(
            (invoiceDetail.redInvoiceOriginal + ',' + redInvoiceOriginalData)
              .split(',')
              .filter(Boolean),
          ).join(',')
          const redParams = {
            relationId: routeParams.id,
            invoiceType: pageType,
            returnOrderIds: getReturnOrderIds(),
            invoiceParams: invoiceListData.map((item) => ({
              id: item.id ?? '',
              invoiceType: item.invoiceType,
              invoiceNum: item.invoiceNum,
              invoiceCode: item.invoiceCode,
              invoiceTime: item.invoiceTime,
              totalAmount: item.totalAmount,
              totalTaxAmount: item.totalTaxAmount,
              totalAmountIncludingTax: item.totalAmountIncludingTax,
              file: item.fileList ? item.fileList[0] : null,
              verificationType: item.verificationType,
              checkCode: processCheckCode(item),
              seller: item.sellerName,
              // relationId: 'TODO',
            })),
            redInvoiceOriginal: invoiceDetail.redInvoiceOriginal
              ? redNumber
              : redInvoiceOriginalData,
            logisticsCompany: logisticsFormData.logisticsCompany,
            logisticsNum: logisticsFormData.logisticsNum,
            isDraft: true,
          }
          res = await SAVE_RED_INVOICE_ENTRY(redParams)
        } else {
          if (routeParams.type === 'lander') {
            res = await LANDER_SAVE_INVOICE({ ...params, dateState: '2' })
          } else {
            res = await SUPPLIER_SAVE_INVOICE({ ...params, dateState: '2' })
          }
        }

        dispatch(setIsTemporaryStorageLoadingAction(false))
        if (isResponseCodeSuccess(res.code)) {
          message.success(res.msg)
          handleClosePage()
        }
      }
    } else {
      if (dataSource.length) {
        if (invoiceListData.length) {
          const numList = invoiceListData.map((item) => item.invoiceNum)
          if (numList.length !== _.uniq(numList).length) {
            message.warning('存在相同发票，请核对后重新提交！')
          } else {
            // if (!checkSellerName(invoiceListData)) {
            //   message.warning('发票销方与订单信息不一致，请核实')
            //   return
            // }
            // if (!checkPayerName(invoiceListData)) {
            //   message.warning('发票购方信息与订单不一致，请核实')
            //   return
            // }
            // 存在未验证且开票日期不是今天的发票则提交验真
            const notPassVerificationInvoice = invoiceListData.filter(
              (item) =>
                item.verificationType === '7' &&
                moment(item.invoiceTime).format('YYYYMMDD') !==
                  moment(new Date()).format('YYYYMMDD'),
            )
            let invoiceList: any = [...invoiceListData]
            if (notPassVerificationInvoice.length) {
              // 获取验真数据
              invoiceList = await getInvoiceVerificationResult(
                notPassVerificationInvoice,
                '7',
              )
            }
            const saveParams = {
              relationId: routeParams.id ?? '',
              invoiceParam: invoiceList.map((item: any) => ({
                id: item.id ?? '',
                file: item.fileList ? item.fileList[0] : null,
                invoiceCode: item.invoiceCode,
                invoiceNum: item.invoiceNum,
                invoiceTime: item.invoiceTime,
                invoiceType: item.invoiceType,
                totalAmount: item.totalAmount,
                totalAmountIncludingTax: item.totalAmountIncludingTax,
                totalTaxAmount: item.totalTaxAmount,
                verificationType: item.verificationType,
                checkCode: processCheckCode(item),
                seller: item.sellerName,
              })),
              supplierId: getSupplierId(),
              userId: getUserId(),
              orderIds: dataSource.map((item) => item.id),
              deleteInvoiceIds: delInvoiceIdList,
              deleteOrderIds: delOrderIdList,
              logisticsCompany: logisticsFormData.logisticsCompany,
              logisticsNum: logisticsFormData.logisticsNum,
              deleteFileIds: deleteFileIds,
            }
            const invoiceVerificationState = invoiceList.map(
              (item: any) => item.verificationType,
            )
            // 获取所有发票的验真状态 只有验真通过和未验真状态(当天开的票，验真系统无法验证)的发票可以提交
            if (judgeCanSubmit(_.uniq(invoiceVerificationState))) {
              // 发票与订单的价税合计满足当前入口的校验规则才可以提交
              if (!isTotalTaxAmoutNotEqualMemo) {
                dispatch(setIsSubmitButtonLoadingAction(true))
                // 提交发票数据
                let res: any = {}

                if (pageType === 'RED') {
                  const redInvoiceOriginalData = uniq(
                    invoiceList
                      .map((item: any) => extractInvoiceNumber(item.note))
                      .filter(Boolean),
                  ).join(',')
                  const redNumber = uniq(
                    (
                      invoiceDetail.redInvoiceOriginal +
                      ',' +
                      redInvoiceOriginalData
                    )
                      .split(',')
                      .filter(Boolean),
                  ).join(',')
                  const redParams = {
                    relationId: routeParams.id,
                    invoiceType: pageType,
                    returnOrderIds: getReturnOrderIds(),
                    invoiceParams: invoiceList.map((item: any) => ({
                      id: item.id ?? '',
                      invoiceType: item.invoiceType,
                      invoiceNum: item.invoiceNum,
                      invoiceCode: item.invoiceCode,
                      invoiceTime: item.invoiceTime,
                      totalAmount: item.totalAmount,
                      totalTaxAmount: item.totalTaxAmount,
                      totalAmountIncludingTax: item.totalAmountIncludingTax,
                      file: item.fileList ? item.fileList[0] : null,
                      verificationType: item.verificationType,
                      checkCode: processCheckCode(item),
                      seller: item.sellerName,
                      // relationId: 'TODO',
                    })),
                    redInvoiceOriginal: invoiceDetail.redInvoiceOriginal
                      ? redNumber
                      : redInvoiceOriginalData,
                    isDraft: false,
                    logisticsCompany: logisticsFormData.logisticsCompany,
                    logisticsNum: logisticsFormData.logisticsNum,
                  }
                  res = await SAVE_RED_INVOICE_ENTRY(redParams)
                } else {
                  if (routeParams.type === 'lander') {
                    res = await LANDER_SAVE_INVOICE({
                      ...saveParams,
                      dateState: '1',
                    })
                  } else {
                    res = await SUPPLIER_SAVE_INVOICE({
                      ...saveParams,
                      dateState: '1',
                    })
                  }
                }
                dispatch(setIsSubmitButtonLoadingAction(false))
                if (isResponseCodeSuccess(res.code)) {
                  dispatch(setAddInvoiceEntrySubmitAction(true))
                  dispatch(setAddInvoiceEntryIdAction(res.data))
                }
              } else {
                message.error(
                  getTotalTaxAmountMismatchMessage(pageType, routeParams.type),
                )
              }
            } else {
              message.error('存在未通过验真的发票，请核对后重新提交！')
            }
          }
        } else {
          message.warning('请添加发票！')
        }
      } else {
        message.warning('请添加订单！')
      }
    }
  }

  // 关闭添加订单弹窗
  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivleAction(false))
  }

  // 表格选中操作
  const onChangeCheck = (selectedRowKeys: any[], selectedRows: any[]) => {
    dispatch(setSelectedRowKeysAction(selectedRowKeys))
    dispatch(setSelectedRowsAction(selectedRows))
  }

  const handleAddClick = () => {
    dispatch(setIsAddModalVisivleAction(true))
  }

  const handleAddFinished = (selectedRows: AllowAccountRes[]) => {
    if (selectedRows.length) {
      // 电商供应商订单判断订单的下单平台是否一致
      // if (routeParams.type === 'lander') {
      //   const platformList = _.uniq(
      //     [...dataSource, ...selectedRows].map((item) => item.platform),
      //   )
      //   if (platformList.length > 1) {
      //     message.warning('不同项目的订单不能一起提交对账单！')
      //     return
      //   }
      // }
      for (const item of selectedRows) {
        if (item.titleOfTheContract !== routeParams.titleOfTheContract) {
          message.error('请勾选相同签约抬头的订单进行开票！')
          return
        }
      }
      dispatch(setDataSourceAction([...dataSource, ...selectedRows]))
      // 设置订单价税合计
      setOrderPrice([...dataSource, ...selectedRows])
      dispatch(setIsAddModalVisivleAction(false))
      const selectIds = selectedRows.map((item) => item.id)
      let delIdList = [...delOrderIdList]
      selectIds.forEach((item) => {
        if (delIdList.includes(item)) {
          delIdList = delIdList.filter((term) => term !== item)
        }
      })
      dispatch(setDelOrderIdListAction(delIdList))
      setOriginRemovedList(
        originRemovedList.filter(
          (item) => selectedRows.findIndex((e) => e.id === item.id) === -1,
        ),
      )
    }
  }

  const handleAddReturnFinished = (selectedRows: RedInvoiceEntryItem[]) => {
    if (selectedRows.length) {
      const finalList = convertToReturnOrderDetailItemList(selectedRows)
      for (const item of finalList) {
        if (item.titleOfTheContractName !== routeParams.titleOfTheContract) {
          message.warning('请勾选相同签约抬头的订单进行开票！')
          return
        }
      }
      if (
        _.uniq(
          [...(dataSource as any), ...selectedRows].map((item) => item.taxRate),
        ).length > 1
      ) {
        message.warning('不同税率的发票不能合并开票')
        return
      }
      dispatch(setDataSourceAction([...dataSource, ...finalList]))
      // // 设置订单价税合计
      setOrderPrice([...dataSource, ...finalList])
      dispatch(setIsAddModalVisivleAction(false))
      const selectIds = finalList.map((item) => item.id)
      let delIdList = [...delOrderIdList]
      selectIds.forEach((item) => {
        if (delIdList.includes(item)) {
          delIdList = delIdList.filter((term) => term !== item)
        }
      })
      dispatch(setDelOrderIdListAction(delIdList))
      setOriginRemovedList(
        originRemovedList.filter(
          (item) => selectedRows.findIndex((e) => e.id === item.id) === -1,
        ),
      )
    }
  }

  const handleClosePage = () => {
    closeCurrentTab()
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  // 删除订单
  const onDelete = () => {
    if (!selectedRowKeys.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
      onOk: () => {
        let list = []
        // 需要针对红票特殊处理
        if (pageType === 'RED') {
          const selectedItem = dataSource?.find((item) => {
            return selectedRowKeys.includes((item as any)?.[FRONT_KEY])
          })
          const delIds = collectRedDelId(dataSource, selectedRowKeys)
          list = dataSource.filter((item) => !delIds.includes(item.id))
          dispatch(setDelOrderIdListAction(delIds))
        } else {
          list = dataSource.filter((item) => !selectedRowKeys.includes(item.id))
          dispatch(setDelOrderIdListAction([...selectedRowKeys]))
        }

        dispatch(setDataSourceAction(list))
        // 设置订单价税合计
        setOrderPrice(list)
        setOriginRemovedList(
          selectedRows.filter((item) => item.type === 'origin'),
        )
        dispatch(setSelectedRowKeysAction([]))
        dispatch(setSelectedRowsAction([]))
      },
    })
  }

  const setOriginRemovedList = (val: AllowAccountRes[]) => {
    dispatch(setOriginRemovedListAction(val))
  }
  const addressInfoMemo = useMemo(() => {
    if (dataSource.length < 1) {
      return null
    }
    let addressType: SendTicketAddressType | undefined = undefined
    dataSource.forEach((item) => {
      if (item.titleOfTheContract === '万聚国际（杭州）供应链有限公司') {
        addressType = '万聚'
      } else if (item.titleOfTheContract === '咸亨国际科技股份有限公司') {
        addressType = '总部'
      }
    })
    if (!addressType) {
      return null
    }
    const addresssInfo =
      sendTicketAddressDict[addressType as SendTicketAddressType]

    return addresssInfo
  }, [dataSource])

  // 复制
  const onCopy = () => {
    // const template = orderTypeData.find((item) => item.des === routeParams.type)
    // ?.address as string
    const info = joinAddressInfo(addressInfoMemo)
    const msgTitle = '线下寄票地址'
    copy(info)
    message.success(`复制${msgTitle}成功`)
  }

  // 导出寄票随单
  const exrpotInvoiceWithOrder = async () => {
    if (dataSource.length) {
      const idList = dataSource.map((item) => item.id)
      if (routeParams.type === 'lander') {
        // 处理红票
        if (isRedTicket) {
          await DOWNLOAD_RED_ACCEPT_TEMP(idList)
          return
        }
        // 电商供应商订单
        POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP(idList)
      } else {
        // 供应商订单
        DOWNLOAD_SUPPLIER_ORDER_ACCEPT_TEMP(idList)
      }
    } else {
      message.error('订单为空！请添加订单 ')
    }
  }

  const changeBatchModalVisible = (
    val: boolean,
    type?: FinanicialInvoiceType,
  ) => {
    dispatch(setOkBtnLoadingAction(false))
    dispatch(setInvoiceBatchModalVisibleAction(val))
    type && dispatch(setInvoiceEntryTypeAction(type))
  }

  // 提交上传发票
  const onBatchModalSubmit = async () => {
    const formData = await invoiceForm.validateFields()
    dispatch(setOkBtnLoadingAction(true))
    const list = formData.invoiceList.map((item: any) => ({
      ...item,
      invoiceTime:
        typeof item.invoiceTime === 'string'
          ? item.invoiceTime
          : moment(moment(item.invoiceTime).format('YYYY-MM-DD')).valueOf(),
      verificationType: '90',
    }))
    dispatch(setInvoiceListDataAction([...invoiceListData, ...list]))
    // 计算发票价税合计
    dispatch(
      setAllInvoicePriceAction(
        getAllPrice([...invoiceListData, ...list], 'totalAmountIncludingTax'),
      ),
    )
    dispatch(setOkBtnLoadingAction(false))
    changeBatchModalVisible(false)
  }

  // 批量导入发票-上传文件
  const uploadFlag = useRef<number>(0)
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    const reg = generateRegExp(FINANCIAL_INVOICE_FILE_TYPE)
    const index = file.name.search(reg)
    if (FileList.length > 10) {
      message.error('上传失败：文件数量超出限制（10个）')
      uploadFlag.current = 0
      return false
    }
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      uploadFlag.current = 0
      return false
    }
    if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      uploadFlag.current = 0
      return false
    }
    uploadFlag.current++
    if (uploadFlag.current === FileList.length) {
      uploadfile(FileList)
      uploadFlag.current = 0
    }
    return false
  }

  // 2.调用接口上传文件
  const uploadfile = async (FileList: RcFile[]) => {
    changeBatchModalVisible(true, 'batchUpload')
    dispatch(setBatchUploadLoadingAction(true))
    const res = await UPLOAD_FILES({ type: 'invoice' }, FileList)
    if (isResponseCodeSuccess(res.code)) {
      await recognizeInvoice(
        res.data.map((item: any) => ({ url: item.url, fileId: item.id })),
      )
      dispatch(setBatchUploadLoadingAction(false))
    }
  }

  // 3.识别发票
  const recognizeInvoice = async (params: RecognizeInvoiceParams[]) => {
    const fileUrls = params.map((item) => item.url).join(',')
    const res = await POST_RECOGNIZE_INVOICE({ fileUrls })
    if (isResponseCodeSuccess(res.code)) {
      const invoiceList = res.data.map((item) => {
        if (
          item.invoiceNum &&
          item.invoiceTime &&
          item.totalTaxAmount &&
          item.totalAmountIncludingTax &&
          item.totalAmount &&
          item.invoiceType
        ) {
          message.success(res.msg)
          return {
            ...item,
            invoiceType: item.invoiceType?.key,
            invoiceTime: item.invoiceTime
              ? moment(Number(item.invoiceTime))
              : null,
            fileList: [
              {
                url: item.url,
                baseUrl: item.baseUrl,
                name: getPicName(item.url),
                id: item.fileId,
              },
            ],
            verificationType: '90',
            checkCode: processCheckCode(item),
          }
        } else {
          message.error(res.msg)
          return {}
        }
      })
      invoiceForm.setFieldsValue({
        invoiceList,
      })
    }
  }

  // 获取表格内input上传的文件
  const getInputFile = (e: any) => {
    const fileList = Object.values(e.target.files) as RcFile[]
    fileList.forEach((item: any) => beforeUpload(item, fileList))
    // 防止第二次选中同一个文件不调用change方法，导致无法重新打开弹框上传并识别文件
    e.target.value = ''
  }

  // 预览
  const showPreviewModal = (url: string) => {
    dispatch(setPreviewFileUrlAction(url))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  // 打包下载附件
  const onPackageDownload = async (files: fileFile[]) => {
    // 获取下载路径
    const url = `${files[0].baseUrl ? files[0].baseUrl : HTTP}${files[0].url}`
    download(url)
  }

  // 删除发票
  const handleDelInvoice = (ind: any) => {
    CustomerConfirm({
      title: '您正在删除发票',
      content: '删除后可重新添加，是否删除？',
      onOk: () => {
        const list = invoiceListData.filter((item, index) => index !== ind)
        dispatch(
          setAllInvoicePriceAction(
            getAllPrice(list, 'totalAmountIncludingTax'),
          ),
        )
        const delInvoice = invoiceListData[ind]
        dispatch(setInvoiceListDataAction(list))
        dispatch(
          setDelInvoiceIdListAction(
            uniq([...delInvoiceIdList, delInvoice.id ?? '']),
          ),
        )
      },
    })
  }

  // 计算价税合计/合计税额
  const getAllPrice = (val: any[], type: string) => {
    if (val.length) {
      return val
        .reduce(
          (accumulator, currentValue) =>
            accumulator + Number(currentValue[type] ?? 0),
          0,
        )
        .toFixed(2)
    } else {
      return 0
    }
  }

  // 打开发票详情弹窗
  const showInvoiceDetailModal = async (record: any, index: number) => {
    // 重置表单数据，避免发票详情弹框回显错误
    invoiceDetailForm.resetFields()
    dispatch(setCurrentInvoiceAction({ ...record, index: index }))
    invoiceDetailForm.setFieldsValue({
      ...record,
      invoiceTime: moment(record.invoiceTime),
    })
    // 打开发票弹窗时，根据当前发票类型判断附件是否必填
    changeInvoiceType(record.invoiceType)
    dispatch(setIsModalOpenAction(true))
    if (record.verificationType !== '4' || record.verificationType === '5') {
      let detailList = []
      if (record.detailList.length) {
        detailList = record.detailList.map((item: any) => ({
          goodsName: item.goods_name,
          standard: item.standard,
          unit: item.unit,
          num: item.num,
          netValue: item.net_value,
          detailAmount: item.detail_amount,
          taxRate: item.tax_rate,
          allTax: item.all_tax,
        }))
        detailList.push({
          goodsName: '合计',
          detailAmount: record.invoiceMoney,
          allTax: record.allTax,
        })
        dispatch(setCheckingResultAction(record.checkingResult))
      } else {
        // 调用接口获取发票详情数据
        const res = await GET_VERIFICATION_RESULT_DATA({
          invoiceNum: record.invoiceNum,
          // invoiceCode: record.invoiceCode,
          // invoiceTime: record.invoiceTime,
          // invoiceType: record.invoiceType,
          // totalAmount: record.totalAmount,
          // totalAmountIncludingTax: record.totalAmountIncludingTax,
          // totalTaxAmount: record.totalTaxAmount,
          // checkCode: record.invoiceType === '04' ? record.checkCode : '',
        })
        if (isResponseCodeSuccess(res.code)) {
          const ret = res.data?.result?.data?.detailList ?? []
          detailList =
            ret.length > 0 &&
            ret.map((item: any) => ({
              goodsName: item.goodsName,
              standard: item.standard,
              unit: item.unit,
              num: item.num,
              netValue: item.netValue,
              detailAmount: item.detailAmount,
              taxRate: item.taxRate,
              allTax: item.allTax,
            }))
          const r = res.data?.result?.data
          detailList.push({
            goodsName: '合计',
            detailAmount: r.invoiceMoney,
            allTax: r.allTax,
          })
          const rs = res.data?.result
          const checkingResult = {
            invoiceNum: rs.invoiceNumber,
            invoiceCode: rs.invoiceCode,
            invoiceTime: rs.invoiceDate,
            invoiceType: rs.invoiceType,
            totalAmount: Number(r.invoiceMoney),
            totalAmountIncludingTax: Number(r.allValoremTax),
            totalTaxAmount: Number(r.allTax),
          }
          dispatch(
            setCurrentInvoiceAction({
              ...record,
              index: index,
              note: r.note,
              checkingResult: checkingResult,
              purchaserName: r.purchaserName + r.purchaserTaxpayerNumber,
            }),
          )
          dispatch(setCheckingResultAction(checkingResult))
        }
      }
      dispatch(setInvoiceDetailDataAction(detailList))
    }
  }

  // 发票详情弹框确认
  const handleInvoiceDetailOk = async () => {
    if (invoiceDetailChangeFlag) {
      // 表单校验
      const formData = await invoiceDetailForm.validateFields()
      const list = invoiceListData.filter(
        (item, index) => index !== currentInvoice.index,
      )
      // 当前发票已验真，填写的数据与验真数据不一致，保存时只修改数据，不用再次提交验真
      if (currentInvoice.verificationType === '5') {
        list.push({
          ...currentInvoice,
          ...formData,
          verificationType: '3',
        })
        // 当前发票验真不通过，修改数据后重新提交验真
      } else {
        const formDataInvoiceTime = moment(
          moment(formData.invoiceTime).format('YYYY-MM-DD'),
        ).valueOf()
        list.push({
          ...currentInvoice,
          ...formData,
          verificationType: '90',
          invoiceTime:
            currentInvoice.invoiceTime !== formDataInvoiceTime
              ? formDataInvoiceTime
              : currentInvoice.invoiceTime,
        })
      }
      dispatch(setInvoiceListDataAction(list))
      dispatch(
        setAllInvoicePriceAction(getAllPrice(list, 'totalAmountIncludingTax')),
      )
      dispatch(setInvoiceDetailChangeFlagAction(false))
    }
    dispatch(setIsModalOpenAction(false))
  }

  // 关闭发票详情弹窗
  const handleInvoiceDetailCancel = () => {
    dispatch(setIsModalOpenAction(false))
  }

  // 发票详情页修改发票文件
  const changeInvoiceFile = async (file: any) => {
    dispatch(setInvoiceDetailChangeFlagAction(true))
    if (file.length) {
      message.loading('发票识别中，请耐心等待......')
      const fileUrls = file.map((item: any) => item.url).join(',')
      const res = await POST_RECOGNIZE_INVOICE({ fileUrls })
      if (isResponseCodeSuccess(res.code)) {
        const resData = res.data
        if (
          resData.every(
            (item) =>
              item.invoiceNum &&
              item.invoiceTime &&
              item.totalTaxAmount &&
              item.totalAmountIncludingTax &&
              item.totalAmount &&
              item.invoiceType,
          )
        ) {
          const fileList = [
            {
              url: resData[0].url,
              baseUrl: resData[0].baseUrl,
              name: getPicName(resData[0].url),
              id: resData[0].fileId,
            },
          ]
          const code = processCheckCode(resData?.[0])
          invoiceDetailForm.setFieldsValue({
            ...resData[0],
            fileList: fileList,
            invoiceType: resData[0].invoiceType.key,
            invoiceTime: moment(Number(resData[0].invoiceTime)),
            verificationType: '90',
            checkCode: code,
          })
          dispatch(
            setCurrentInvoiceAction({
              ...currentInvoice,
              fileList: fileList,
              verificationType: '90',
              checkCode: code,
            }),
          )
          message.success('识别成功！')
        } else {
          message.error('识别失败！')
        }
      }
    } else {
      if (currentInvoice.fileList[0].id) {
        dispatch(
          setDeleteFileIdsAction(
            uniq([...deleteFileIds, currentInvoice.fileList[0].id]),
          ),
        )
      }
      invoiceDetailForm.setFieldsValue({
        ...currentInvoice,
        fileList: [],
        verificationType: '90',
        invoiceTime: invoiceDetailForm.getFieldValue('invoiceTime'),
      })
      dispatch(setCurrentInvoiceAction({ ...currentInvoice, fileList: [] }))
    }
  }

  // 发票详情弹框表单修改
  const invoiceDetailChange = () => {
    dispatch(setInvoiceDetailChangeFlagAction(true))
  }

  // 一键填充
  const handlefillingResult = () => {
    dispatch(setInvoiceDetailChangeFlagAction(true))
    invoiceDetailForm.setFieldsValue({
      ...currentInvoice,
      ...currentInvoice.checkingResult,
      invoiceTime: moment(currentInvoice.checkingResult.invoiceTime),
    })
    dispatch(
      setCurrentInvoiceAction({
        ...currentInvoice,
        ...currentInvoice.checkingResult,
      }),
    )
  }

  // 调用验真接口
  const handleVerificationInvoice = async () => {
    dispatch(setExrpotInvoiceTipAction(false))
    // 发票列表数据更新，判断是否展示导出寄票随单提示
    invoiceListData.forEach((item) => {
      if (item.fileList) {
        if (!item.remarks) {
          dispatch(setExrpotInvoiceTipAction(true))
          return
        }
      }
    })
    // 发票列表数据更新，判断发票验真结果
    const waitVerificationList = invoiceListData.filter(
      (item) => item.verificationType === '90',
    )
    // 获取验真数据
    getInvoiceVerificationResult(waitVerificationList, '90')
  }

  // 获取验真数据
  const getInvoiceVerificationResult = async (
    waitverificationInvoiceList: any,
    type: string,
  ) => {
    let verificationOverList: any = []
    // 验真状态是未验真的发票且开票日期是当天的/验真过的无需验真
    if (type === '7') {
      verificationOverList = invoiceListData.filter(
        (item) =>
          item.verificationType !== type ||
          (item.verificationType === type &&
            moment(item.invoiceTime).format('YYYYMMDD') ===
              moment(new Date()).format('YYYYMMDD')),
      )
    } else {
      verificationOverList = invoiceListData.filter(
        (item) => item.verificationType !== type,
      )
    }
    const data = await Promise.all(
      waitverificationInvoiceList.map(async (item: any) => {
        const res = await INVOICE_VERIFICATION({
          ...item,
          invoiceCode: item.invoiceCode || '',
          totalTaxAmount: item.totalTaxAmount || '',
          relationId: routeParams.id || '',
          orderType: routeParams.orderType || '',
          titleOfTheContract: routeParams.titleOfTheContract || '',
          supplierId: getSupplierId(),
          invoiceSeller: item.sellerName,
          sellerName: GetLocalStorage('ENTERPRISE_NAME'),
          apiSource: '1',
        })
        if (isResponseCodeSuccess(res.code)) {
          return res.data
        } else {
          return {}
        }
      }),
    )
    if (data.length) {
      const newInvoiceListData = waitverificationInvoiceList.map(
        (item: any, index: number) => {
          const curData: any = data[index]
          if (
            curData &&
            curData.resultType &&
            curData.resultType.key !== '1' &&
            curData.resultType.key !== '4' &&
            curData.resultType.key !== '6' &&
            curData.resultType.key !== '7'
          ) {
            const cueInvoiceDetailInfo =
              curData.invoiceVerificationInfo.result.data
            return {
              ...item,
              verificationType: curData.resultType.key,
              detailList: cueInvoiceDetailInfo.detailList,
              note: cueInvoiceDetailInfo.note,
              invoiceMoney:
                curData.invoiceVerificationInfo.result.data.invoice_money,
              allTax: curData.invoiceVerificationInfo.result.data.all_tax,
              checkingResult: {
                invoiceNum:
                  curData.invoiceVerificationInfo.result.invoice_number,
                invoiceCode:
                  curData.invoiceVerificationInfo.result.invoice_code,
                invoiceTime:
                  curData.invoiceVerificationInfo.result.invoice_date,
                invoiceType:
                  curData.invoiceVerificationInfo.result.invoice_type,
                totalAmount: cueInvoiceDetailInfo.invoice_money,
                totalAmountIncludingTax: cueInvoiceDetailInfo.all_valorem_tax,
                totalTaxAmount: cueInvoiceDetailInfo.all_tax,
              },
              purchaserName:
                cueInvoiceDetailInfo.purchaser_name +
                cueInvoiceDetailInfo.purchaser_taxpayer_number,
            }
          } else {
            return {
              ...item,
              verificationType: curData.resultType
                ? curData.resultType.key
                : '6',
            }
          }
        },
      )
      dispatch(
        setInvoiceListDataAction([
          ...verificationOverList,
          ...newInvoiceListData,
        ]),
      )
      return [...verificationOverList, ...newInvoiceListData]
    }
  }

  // 手动重新调用验真接口
  const reloadVerificationInvoice = async (record: any, ind: number) => {
    const res = await INVOICE_VERIFICATION({
      ...record,
      invoiceCode: record.invoiceCode || '',
      totalTaxAmount: record.totalTaxAmount || '',
      relationId: routeParams.id || '',
      orderType: routeParams.orderType || '',
      titleOfTheContract: routeParams.titleOfTheContract || '',
      supplierId: getSupplierId(),
      invoiceSeller: record.sellerName,
      sellerName: GetLocalStorage('ENTERPRISE_NAME'),
      apiSource: '1',
    })
    let newInvoiceItem = {}
    if (
      isResponseCodeSuccess(res.code) &&
      res.data.resultType &&
      res.data.resultType.key !== '1' &&
      res.data.resultType.key !== '4' &&
      res.data.resultType.key !== '6'
    ) {
      // 验真通过修改数据
      newInvoiceItem = {
        ...record,
        verificationType: res.data.resultType.key,
        detailList: res.data.invoiceVerificationInfo.result.data.detailList,
        note: res.data.invoiceVerificationInfo.result.data.note,
        invoiceMoney:
          res.data.invoiceVerificationInfo.result.data.invoice_money,
        allTax: res.data.invoiceVerificationInfo.result.data.all_tax,
        checkingResult: {
          invoiceNum: res.data.invoiceVerificationInfo.result.invoice_number,
          invoiceCode: res.data.invoiceVerificationInfo.result.invoice_code,
          invoiceTime: res.data.invoiceVerificationInfo.result.invoice_date,
          invoiceType: res.data.invoiceVerificationInfo.result.invoice_type,
          totalAmount:
            res.data.invoiceVerificationInfo.result.data.invoice_money,
          totalAmountIncludingTax:
            res.data.invoiceVerificationInfo.result.data.all_valorem_tax,
          totalTaxAmount: res.data.invoiceVerificationInfo.result.data.all_tax,
        },
      }
    } else {
      // 接口调用失败
      newInvoiceItem = {
        ...record,
        verificationType: '6',
      }
    }
    const list = invoiceListData.filter((item, index) => index !== ind)
    list.push(newInvoiceItem)
    dispatch(
      setAllInvoicePriceAction(getAllPrice(list, 'totalAmountIncludingTax')),
    )
    dispatch(setInvoiceListDataAction(list))
  }

  // 提交成功 跳转至发票详情页面
  const jumpToInvoiceDetail = () => {
    // 点击后将标识置为false展示详情页，避免在详情页下提交点击后页面数据异常
    dispatch(setAddInvoiceEntrySubmitAction(false))
    // 当前在新增页面时提交成功关闭页面并跳转至详情页
    if (pathname === '/srm/addInvoiceEntry') {
      handleClosePage()
      const url = supRoute + '/invoiceDetail'
      history.replace({
        pathname: url,
        state: {
          id: addInvoiceEntryId,
          type: routeParams.type,
        },
      })
      // 发票单状态为驳回时重新提交后刷新页面数据
    } else {
      // 获取最新数据
      getData({ id: addInvoiceEntryId, ...routeState })
    }
  }

  // 修改发票列表列数据
  const changeInvoiceListColumns = (state: string, columns: any[]) => {
    if (state === '1' || state === '3') {
      return columns.filter((item) => item.key !== 'operate')
    } else {
      return columns
    }
  }

  // 获取详情数据
  const getData = async (params: RouteParams) => {
    dispatch(setPageLoadingAction(true))
    let res: any = {}
    if (params.type === 'lander') {
      res = await GET_INVOICE_DETAIL_DATA({
        relationDataId: params.id as string,
      })
    } else {
      res = await GET_SUPPLIER_INVOICE_DETAIL_DATA({
        relationDataId: params.id as string,
      })
    }

    if (isResponseCodeSuccess(res.code)) {
      dispatch(setInvoiceDetailAction(res.data))
      // 发票列表 (设置发票详情列表为空数据，点击发票号时调用接口获取详情数据)
      const invoiceList = res.data.invoices.map((item: InvoiceParamItem) => ({
        ...item,
        detailList: [],
        fileList: item.file
          ? [
              {
                ...item.file,
                name: '附件',
                baseUrl: GetLocalStorage('BASEURL'),
              },
            ]
          : [],
      }))
      dispatch(setInvoiceListDataAction(invoiceList))
      // 设置发票价税合计
      dispatch(
        setAllInvoicePriceAction(
          Number(res.data.invoiceTotalAmountIncludingTax),
        ),
      )
      if (pageType === 'RED') {
        const list = convertDetailToReturnOrderDetailItemList(
          res.data?.returnDetailList || [],
        )
        dispatch(setDataSourceAction(list))
        setOrderPrice(list)
      } else {
        // 订单明细
        dispatch(setDataSourceAction(res.data.orders))
      }

      if (pageType !== 'RED') {
        // 设置订单价税合计
        dispatch(
          setAllOrderPriceAction(Number(res.data.orderTotalAmountIncludingTax)),
        )
      }

      // 设置物流信息
      const logisticsInfo = {
        logisticsCompany: res.data.logisticsCompany,
        logisticsNum: res.data.logisticsNum,
      }
      logisticsInfoForm.setFieldsValue(logisticsInfo)
      dispatch(setLogisticsInfoAction(logisticsInfo))
      dispatch(setPageLoadingAction(false))
    }
  }

  // 获取物流公司列表
  const getExpressList = async () => {
    const res = await GET_OMS_EXPRESSCOMPANY_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setLogisticsCompanyListAction(res.data))
    }
  }

  // 保存物流信息
  const saveLogisticsInfo = async () => {
    const logisticsFormData = logisticsInfoForm.getFieldsValue()
    if (logisticsFormData.logisticsCompany && logisticsFormData.logisticsNum) {
      const params = {
        logisticsCompany: logisticsFormData.logisticsCompany,
        logisticsNum: logisticsFormData.logisticsNum,
        invoiceOrderId: routeParams.id as string,
      }
      const res = await SAVE_INVOICE_LOGISTICS({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success(res.msg)
        dispatch(
          setLogisticsInfoAction({
            logisticsCompany: logisticsFormData.logisticsCompany,
            logisticsNum: logisticsFormData.logisticsNum,
          }),
        )
      }
    } else {
      if (!logisticsFormData.logisticsCompany) {
        message.warning('请选择物流公司！')
      } else if (!logisticsFormData.logisticsNum) {
        message.warning('请输入物流单号')
      }
    }
  }

  // 修改发票种类时，判断附件是否必传
  const changeInvoiceType = (type: string) => {
    if (
      invoiceTypeEnum.isLabelsMatchValue(
        [
          '增值税电子专用票',
          '电子发票（增值税专用发票）',
          '增值税电子普通发票',
          '电子发票（普通发票）',
        ],
        type,
      )
    ) {
      dispatch(setFileRequireAction(true))
    } else {
      dispatch(setFileRequireAction(false))
    }
  }

  // 判断当前发票列表数据是否可以提交
  const judgeCanSubmit = (arr: string[]) => {
    if (arr.length === 1) {
      // 7-当天票未验真  3-已验真
      if (arr.includes('7') || arr.includes('3')) {
        return true
      }
    } else if (arr.length === 2) {
      if (arr.includes('7') && arr.includes('3')) {
        return true
      }
    }
    return false
  }

  // 缓存发票页物流信息
  const onLogisticsInfoFormChange = () => {
    dispatch(setLogisticsInfoAction(logisticsInfoForm.getFieldsValue()))
  }

  // 设置订单价税合计
  const setOrderPrice = (data: any[]) => {
    if (isRedTicket) {
      const sums = bigCalc.sumListByFieldNameBig(
        data,
        'totalAmountIncludingTax',
      )
      dispatch(setAllOrderPriceAction(sums.toFixed(2)))
      return
    }
    if (routeParams.type === 'lander') {
      // 电商供应商订单价税合计
      dispatch(
        setAllOrderPriceAction(getAllPrice(data, 'totalAmountIncludingTax')),
      )
    } else {
      // 供应商订单价税合计
      dispatch(setAllOrderPriceAction(getAllPrice(data, 'finalPrice')))
    }
  }

  useEffect(() => {
    getExpressList()
    const flag = getpagecache()
    if (flag && !routeState) {
      dispatch(reloadStateAction(flag))
      logisticsInfoForm.setFieldsValue(flag.logisticsInfo)
    } else {
      dispatch(setRouteParamsAction(routeState))
      if (routeState.data) {
        dispatch(setDataSourceAction(routeState.data))
        setOrderPrice(routeState.data || [])
      }
      // 点击发票号跳转至详情页 调用接口获取页面详情数据
      if (routeState.id) {
        getData(routeState)
      }
    }
    // eslint-disable-next-line
  }, [])

  // 发票列表数据变更时，判断验真状态
  useEffect(() => {
    if (invoiceListData.length) {
      handleVerificationInvoice()
    }
    // eslint-disable-next-line
  }, [invoiceListData])

  // 订单列表无数据时，禁用'暂存'按钮
  useEffect(() => {
    if (!dataSource.length) {
      dispatch(setTemporaryStorageDisabledAction(true))
    } else {
      dispatch(setTemporaryStorageDisabledAction(false))
    }
  }, [dataSource])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  // // invoiceListData：发票
  // const checkSellerName = (invoiceListData: any) => {
  //   const sellerNameList = invoiceListData.map(
  //     (item: { sellerName: string }) => item.sellerName,
  //   )
  //   return sellerNameList?.every(
  //     (item: string) => convertToFullWidth(item) === getSupplierName(),
  //   )
  // }

  // const checkPayerName = (invoiceListData: any) => {
  //   const payerNameList = invoiceListData.map(
  //     (item: { payerName: string }) => item.payerName,
  //   )
  //   return payerNameList?.every(
  //     (item: string) => convertToFullWidth(item) === getSupplierName(),
  //   )
  // }

  return {
    hooksState: state,
    addressInfoMemo,
    fileInput,
    handleAddClick,
    handleAddOrderModalCancel,
    handleAddFinished,
    handleSubmit,
    onChangeCheck,
    handleClosePage,
    handleFormDataChange,
    onDelete,
    onCopy,
    exrpotInvoiceWithOrder,
    invoiceForm,
    invoiceDetailForm,
    changeBatchModalVisible,
    onBatchModalSubmit,
    beforeUpload,
    getInputFile,
    showPreviewModal,
    cancelPreviewModal,
    onPackageDownload,
    handleDelInvoice,
    showInvoiceDetailModal,
    handleInvoiceDetailOk,
    handleInvoiceDetailCancel,
    changeInvoiceFile,
    invoiceDetailChange,
    handlefillingResult,
    reloadVerificationInvoice,
    jumpToInvoiceDetail,
    changeInvoiceListColumns,
    logisticsInfoForm,
    saveLogisticsInfo,
    changeInvoiceType,
    onLogisticsInfoFormChange,
    handleAddReturnFinished,
    isTotalTaxAmoutNotEqualMemo,
  }
}

export default UseAddInvoiceEntryHook
